<template>
  <div class="container">
    <div class="row dashBoardOrdersWrapper">
       <div class="col-md-4">
        <h2><span class="fontIcon"><font-awesome-icon :icon="['fal', 'file-alt']"></font-awesome-icon></span> {{ msg }}</h2>
      </div>
      <div class="content-section implementation dataview-demo">
        <DataTable class="orderlist" stateStorage="session" stateKey="feralcoOrdersList" :autoLayout="false" :value="orders" data-key="id" :selection.sync="selectedOrder" @row-select="orderDetails(selectedOrder, ordersSchema)" selectionMode="single" :filters="filters" :paginator="true" :rows="40">
          <template #header>
            <div style="text-align: left">
              <i class="pi pi-search" style="margin: 4px 4px 0px 0px;"></i>
              <InputText v-model="filters['global']" placeholder="Sökfilter" size="50" />
            </div>
          </template>
            <Column field="state" header="Status" filterMatchMode="in" :sortable="true">
               <template #body="slotProps">
                 <div :class="[slotProps.data.state]">
                    <span>{{slotProps.data.state}}</span>
                    <i v-if="slotProps.data.needsAttention" class="pi pi-bell needsAttention"></i>
                  </div>
              </template>
              <template #filter>
                <MultiSelect v-model="filters['state']" :options="filterOptions" optionLabel="label" optionValue="value" placeholder="Filtrera.." />
              </template>
            </Column>
            <Column field="DateDeliveryEarly" header="Lev tidigast" :sortable="true">
              <template #body="slotProps" >
                {{slotProps.data.data.DateDeliveryEarly}}
              </template>
            </Column>
            <Column field="data.DateDeliveryLate" header="Lev senast" :sortable="true">
              <template #body="slotProps" >
               <span>{{slotProps.data.data.DateDeliveryLate}}</span>
            </template>
            </Column>
            <Column field="data.SalesId" header="Order" :sortable="true"/>
            <Column field="data.DeliveryPlaceCity" header="Ort" :sortable="true"/>
            <Column field="data.GroupLoading" header="Samlast" :sortable="true" />
            <Column field="data.ItemId" header="Produkt" :sortable="true">
                <template #body="slotProps">
                  <span :class="checkIfSol(slotProps.data.data.ItemId)">{{slotProps.data.data.ItemId}}</span>
                </template>
            </Column>
            <Column field="data.Quantity" header="Kvantitet" :sortable="true" bodyStyle="text-align:right;" headerStyle="text-align:right;">
              <template #body="slotProps">
                {{parseFloat(slotProps.data.data.Quantity.replace(',','.')).toFixed(2).toLocaleString()}}
              </template>
            </Column>
             <Column field="data.DeliveryPlaceComments" header="">
              <template #body="slotProps">
                <div v-if="slotProps.data.data.DeliveryPlaceComments || slotProps.data.data.InternDeliveryPlaceComments" class="commentInfoIcon">
                    <b-button class="commentBtn" v-b-tooltip.hover :title="setComment(slotProps.data.data.InternDeliveryPlaceComments, slotProps.data.data.DeliveryPlaceComments)">
                     <i class="pi pi-comment"></i>
                    </b-button>
                </div>
              </template>
             </Column>
             <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button icon="pi pi-ban" @click="archiveOrder(slotProps.data.id)" />
                </template>
            </Column>
        </DataTable>
    </div>
    </div>
    <Toast position="topright" />
  </div>
</template>
<script>
import 'primeflex/primeflex.css'
import Toast from 'primevue/toast'
import DataViewPrime from 'primevue/dataview'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import MultiSelect from 'primevue/multiselect'
import Column from 'primevue/column'
import Button from 'primevue/button'
export default {
  name: 'FeralcoOrdersList',
  components: {
    'DataView': DataViewPrime,
    InputText,
    MultiSelect,
    Toast,
    DataTable,
    Column,
    Button,
    'Dropdown': Dropdown
  },
  data () {
    return {
      msg: 'Feralco ordrar',
      activeBtn: 'all',
      orders: [],
      orderTypes: [],
      ordersSchema: {},
      endCustomerName: '',
      layout: 'list',
      sortKey: null,
      sortOrder: null,
      sortField: null,
      selectedOrder: null,
      filters: {},
      sortOptions: [
        {label: 'Nyast', value: '!data_DateLoadingEarly'},
        {label: 'Äldst', value: 'data_DateLoadingEarly'}
      ],
      selectedFilter: null,
      filterOptions: [
        {label: 'Nya', value: 'ny'},
        {label: 'Uppdaterade', value: 'uppdaterad'},
        {label: 'Preliminära', value: 'preliminär'},
        {label: 'Klara för lastning', value: 'redo'},
        {label: 'Skickade', value: 'skickad'},
        {label: 'Aktiva', value: 'aktiv'},
        {label: 'Lastade', value: 'lastad'},
        {label: 'Avslutade', value: 'avslutad'},
        {label: 'Fakturerade', value: 'fakturerad'},
        {label: 'Redo för fakturering', value: 'fakturaredo'}
      ]
    }
  },
  props: {
    id: ''
  },
  async mounted () {
    var response = await this.getOrders()
    this.orders = response.orders.filter((el) => el.state !== 'makulerad')
    this.ordersSchema = response.schema
    this.orderTypes = await this.getOrderTypes()
  },
  computed: {
    roundedQuantity () {
      return this.orders.map(function (item) {
        if (item.data.Quantity) {
          return parseFloat(item.data.Quantity).toFixed(2)
        } else {
          return item.data.Quantity
        }
      })
    },
    flattenedOrders () {
      let flattenedOrders = this.orders
      var flattenedArray = []
      flattenedOrders.forEach((order) => {
        order = this.flattenObj(order)
        flattenedArray.push(order)
      })
      return flattenedArray
    }
  },
  methods: {
    setComment (internal, external) {
      let comments = ''
      if (internal !== undefined) {
        comments = internal
      }
      if (external !== undefined) {
        comments += ' ' + external
      }
      return comments
    },
    flattenObj (obj, parent, res = {}) {
      for (let key in obj) {
        let propName = parent ? parent + '_' + key : key
        if (typeof obj[key] === 'object') {
          this.flattenObj(obj[key], propName, res)
        } else {
          res[propName] = obj[key]
        }
      }
      return res
    },
    async filterOrders (btnState) {
      this.activeBtn = btnState
      var response = await this.getOrders()
      if (btnState !== 'all') {
        this.orders = response.orders.filter((el) => el.state === btnState)
      } else {
        this.orders = response.orders.filter((el) => el.state !== 'makulerad')
      }
    },
    formatDate (theDate) {
      let noYear = new Date(theDate)
      noYear = ('0' + (noYear.getMonth() + 1)).slice(-2) + '-' + noYear.getDate()
      return noYear
    },
    checkIfSol (productItem) {
      if (productItem.startsWith('SOL')) {
        return 'SOL'
      } else {
        return ''
      }
    },
    orderDetails (order, ordersSchema) {
      this.$router.push({ name: 'FeralcoOrdersDetails', params: { id: order.id, schema: ordersSchema } })
    },
    async getOrders () {
      let response = await this.$http.get('/api/orders/by-type/' + this.$props.id)
      return response.data
    },
    async getOrderTypes () {
      let response = await this.$http.get('/api/orders/types')
      return response.data
    },
    archiveOrder (id) {
      let message = 'Vill du arkivera ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.$http
            .put('/api/orders/' + id + '/changestate/arkiverad')
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Order arkiverad', life: 3000})
              const i = this.orders.map(item => item.id).indexOf(id)
              this.orders.splice(i, 1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onSortChange (event) {
      this.sortField = event
      if (this.sortKey === event) {
        this.sortKey = null
        this.sortOrder = -1
      } else {
        this.sortKey = event
        this.sortOrder = 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/FeralcoOrdersList.vue